import React from "react";
import { useVsiAppContext} from "../../../stores/VsiApp";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import Grid from "../../../components/Grid";
import {dateFormatter, numberFormatter} from "../../../utils/gridFormatters";
import {Card} from "reactstrap";


const colDefs = [
    {
        "field": "vm_name",
        "headerName": "VM Name",
        "enableRowGroup": true,
    },
    {
        "field": "storage_size",
        "headerName": "Storage Size",
        "cellRenderer": numberFormatter,
        aggFunc: "sum",
        "enableRowGroup": true,
    },
    {
        "field": "last_backup_status",
        "headerName": "Backup Current",
        "enableRowGroup": true,
    },
    {
        "field": "last_successful_backup_date",
        "headerName": "Last Successful Backup Date",
        "cellRenderer": dateFormatter,
        "enableRowGroup": true,
    },
    {
        "field": "geo_location",
        "headerName": "Location",
        "enableRowGroup": true,
    },
    {
        "field": "cluster_name",
        "headerName": "Cluster Name",
        "enableRowGroup": true,
        "hide": true,
    },
    {
        "field": "data_center",
        "headerName": "Data Center",
        "enableRowGroup": true,
        "hide": true,
    },
    {
        "field": "env_tag",
        "headerName": "Env Tag",
        "enableRowGroup": true,
        "hide": true,
    },
    {
        "field": "power_state",
        "headerName": "Power State",
        "enableRowGroup": true,
        "hide": true,
    },
    {
        "field": "os",
        "headerName": "OS",
        "enableRowGroup": true,
        "hide": true,
    },
]

export default function BackupVmAuditReport({title, context}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    let route = `/api/v6/report/backup_vm_audit_report_proc?client_id=${client.clientId}&period_id=${periodId}`;
    const [data, {isLoading}] = useDataWithRoute(route);

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Backup VM Audit Report</VsiH4>
            <VsiBubble>
                <Grid
                    data={data.recordset}
                    columnDefs={colDefs}
                    isLoading={isLoading}
                />
            </VsiBubble>
        </Card>
    )
}
